var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewAsset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.35 8.4c0 4.446 3.604 8.05 8.05 8.05 4.446 0 8.05-3.604 8.05-8.05 0-4.446-3.604-8.05-8.05-8.05C3.956.355.355 3.956.35 8.4zm3.5-.35c0-.387.313-.7.7-.7h2.625c.097 0 .175-.078.175-.175V4.55c0-.387.313-.7.7-.7h.7c.387 0 .7.313.7.7v2.625c0 .097.078.175.175.175h2.625c.387 0 .7.313.7.7v.7c0 .387-.313.7-.7.7H9.625c-.097 0-.175.078-.175.175v2.625c0 .387-.313.7-.7.7h-.7c-.387 0-.7-.313-.7-.7V9.625c0-.097-.078-.175-.175-.175H4.55c-.387 0-.7-.313-.7-.7v-.7z",
    transform: "translate(-984 -356) translate(969 344) translate(15 12)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewAsset);
export default __webpack_public_path__ + "static/media/new-asset.c4524475.svg";
export { ForwardRef as ReactComponent };